import { APICore } from 'src/helpers/api/apiCore';
import config from 'src/config';
const apiBaseUrl = config.API_URL;
const api = new APICore();

// update Result Set
function updateResetPassword(params: any) {
    const baseUrl = '/users/updatePwd';
    return api.update(`${baseUrl}`, params);
}

export { updateResetPassword };
